<template>
    <div
        class="room-card main-text"
        v-if="room"
        @click="openRoom"
        :class="{'room-card__large': room && room.nearest_check_in_date}"
    >
        <div v-if="room">
            <v-layout justify-space-between align-center pa-0 ma-0 mb-4 row>
                <v-tooltip top content-class="arrow-down" v-model="showTooltip">
                    <template v-slot:activator="{}">
                        <v-flex
                            xs6
                            class="bold-text justify-start room-card__name"
                            ref="mightOverflow"
                            @mouseenter="checkOverflow"
                            @mouseleave="showTooltip = false"
                        >
                            <slot name="roomName"></slot>
                            <div class="close-btn ml-2" v-if="edit" @click.stop.prevent="openEditRoom">
                                <v-img max-height="18px" max-width="18px" :src="require('@/assets/icons/edit_icon.svg')" class="d-inline-flex"/>
                            </div>
                        </v-flex>
                    </template>
                    <div class="main-text">
                        №{{room.name}}
                    </div>
                </v-tooltip>
                <v-flex xs6 class="d-inline-flex justify-end align-center">
                    <span> {{ status[room.free].name }} </span>
                    <div class="d-inline-flex align-center">
                        <div class="status-point ml-2" :class="status[room.free].class"></div>
                        <div class="close-btn ml-2" v-if="edit" @click.stop.prevent="openDeleteRoom">
                            <v-img max-height="18px" :src="require('@/assets/icons/close_icon.svg')" class="d-inline-flex"/>
                        </div>
                    </div>
                </v-flex>
            </v-layout>
            <v-layout pa-0 ma-0 mb-4 row align-center>
                <v-img max-width="28px" max-height="28px" :src="require('@/assets/icons/room_icon.svg')" class="mr-2" />
                <v-flex class="last-info">
                    Последняя сработка: {{getTime(room.last_activity)}}
                </v-flex>
            </v-layout>
        </div>
        <v-layout pa-0 ma-0 row align-center>
            <v-btn
                class="main-text btn-gradient"
                @click.stop.prevent="openModalCreate"
                v-if="room.free"
                :disabled="disabled"
                :class="{'short-btn': room.nearest_check_in_date}"
            >
                Заселить
            </v-btn>
            <v-btn class="main-text btn-grey" @click.stop.prevent="openModalDelete" :disabled="disabled" v-if="!room.free">
                Выселить
            </v-btn>
            <div class="shedule-icon ml-3" @click.stop.prevent="showShedule" v-if="room.nearest_check_in_date || !room.free">
                <v-img max-width="28px" max-height="28px" :src="require('@/assets/icons/schedule.svg')" />
            </div>
            <div class="shedule-icon ml-3" @click.stop.prevent="openQR" v-if="!room.free">
                <v-img max-width="28px" max-height="28px" :src="require('@/assets/icons/qrcode_icon.svg')" />
            </div>
<!--            <div class="shedule-icon ml-2" @click.stop.prevent="openModalCreate">-->
<!--                <v-img max-height="18px" max-width="18px" :src="require('@/assets/icons/pencil_pink_icon.svg')"/>-->
<!--            </div>-->
        </v-layout>
        <v-layout pa-0 ma-0 row align-center justify-end v-if="room" class="small-text grey-text">
            <v-flex xs12 v-if="room.nearest_check_in_date" class="d-flex mt-4">
                Следующее заселение: {{getTime(room.nearest_check_in_date.valid_after)}}
            </v-flex>
            <v-flex v-else xs12 class="d-flex mt-4">
                Ближайшее заселение: нет брони
            </v-flex>
        </v-layout>
        <ModalAddGuest
            v-model="modalCreate"
            :room="room.uid"
            :name="room.name"
            :close="closeModalCreate"
            :edit="editDate"
            @updateRoom="updateRoom"
        />
        <ModalCalendar
            v-model="modalCalendar"
            :schedule="roomSchedule"
            @editCheckIn="openModalCreate"
        />
        <ModalWaiting
            ref="modalWaitingHotels"
            :title="titleLoading"
            :no-cancel="!errorSchedule"
            :no-loading="roomSchedule && roomSchedule.length == 0"
        ></ModalWaiting>
        <ModalQRCode v-model="modalQRCode" :qrlink="qrlink" :name="room.name"></ModalQRCode>
        <ModalDeleteConfirm
            v-model="modalRoomDelete"
            :close="closeDeleteRoom"
            :url="`/hotels/hotel-admin/rooms/${room.uid}/`"
        >
            <template #deleteTitle>
                Вы действительно хотите <br> удалить номер {{room.name}}?
            </template>
        </ModalDeleteConfirm>
        <ModalDeleteConfirm
            v-model="modalDelete"
            :close="closeModalDelete"
            :url="`/hotels/hotel-admin/master-key-for-room/${room.current_check_in}/`"
            submit-title="Выселить"
        >
            <template #deleteTitle>
                Вы действительно хотите <br> выселить гостей до окончания <br> срока их пребывания?
            </template>
            <template #deleteSubtitle>
                После выселения у гостей пропадёт <br> доступ к управлению устройствами
            </template>
        </ModalDeleteConfirm>
    </div>
</template>

<script>
import { updateTime } from '@/utils/index';
import ModalAddGuest from "@/components/modals/ModalAddGuest";
import ModalCalendar from "@/components/modals/ModalCalendar";
import ModalWaiting from "@/components/modals/ModalWaiting";
import ModalQRCode from "@/components/modals/ModalQRCode";
import ModalDeleteConfirm from "@/components/modals/ModalDeleteConfirm";

export default {
    name: "RoomComponent",
    components: {ModalAddGuest, ModalDeleteConfirm, ModalCalendar, ModalWaiting, ModalQRCode},
    props: {
        data: {
            type: [Array, Object],
            required: true,
        },
        edit: {
            type: Boolean,
            default: false,
        },
        showLocation: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            status: [
                {
                    name: "Занят",
                    class: "red-point",
                },
                {
                    name: "Свободен",
                    class: "green-point",
                },
            ],
            room: {},
            roomStatus: 0,
            modalCreate: false,
            modalDelete: false,
            modalRoomDelete: false,
            modalCalendar: false,
            disabled: true,
            roomSchedule: [],
            titleLoading: "Загрузка расписания заселения",
            errorSchedule: false,
            showTooltip: false,
            qrlink: null,
            modalQRCode: false,
            editDate: null,
        };
    },
    created() {
        if (this.data) {
            this.setRoom();
        }
        if (this.$store.state.canEditStructureHotels && this.$store.state.canEditStructureHotels == "true") {
            this.disabled = false;
        }
    },
    watch: {
        data(val) {
            if (val) {
                this.setRoom();
            }
        },
    },
    methods: {
        setRoom() {
            this.room = JSON.parse(JSON.stringify(this.data));
            this.room.free = this.room.free ? 1 : 0;
        },
        openModalCreate(date = null) {
            if (date.valid_after) {
                this.modalCalendar = false;
                this.editDate = date;
            }
            this.modalCreate = true;
        },
        openModalDelete() {
            this.modalDelete = true;
        },
        openDeleteRoom() {
            this.modalRoomDelete = true;
        },
        openEditRoom() {
            this.$emit("editRoom");
        },
        closeModalCreate() {
            this.editDate = null;
            this.modalCreate = false;
        },
        closeModalDelete() {
            this.modalDelete = false;
        },
        closeDeleteRoom() {
            this.modalRoomDelete = false;
        },
        getTime(time) {
            return updateTime(time);
        },
        openRoom() {
            this.$router.push({ name: "roompage", params: { id: this.room.uid } });
        },
        showShedule() {
            this.errorSchedule = false;
            this.titleLoading = "Загрузка расписания заселения";
            this.$refs.modalWaitingHotels.open();
            this.roomSchedule = [];
            this.$http.get('/hotels/hotel-admin/list-check-in-for-room/' + this.room.uid)
                .then((response) => {
                    this.roomSchedule = response.data.results;
                    if (response.data.count == 0) {
                        this.titleLoading = "Нет запланированных заселений";
                        this.errorSchedule = true;
                    } else {
                        this.$refs.modalWaitingHotels.close();
                        this.modalCalendar = true;
                    }
                })
                .catch((error) => {
                    console.log(error);
                    this.$refs.modalWaitingHotels.close();
                    this.titleLoading = "Ошибка загрузки расписания заселения";
                    this.errorSchedule = true;
                });
        },
        checkOverflow() {
            if (this.$refs.mightOverflow.offsetWidth < this.$refs.mightOverflow.scrollWidth){
                this.showTooltip = true;
            } else {
                this.showTooltip = false;
            }
        },
        openQR() {
            this.$http.get('/hotels/hotel-admin/actual-master-key-for-room/' + this.room.uid + '/')
                .then((response) => {
                    this.qrlink = response.data.key;
                    if (this.qrlink) {
                        this.modalQRCode = true;
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        updateRoom(data) {
            this.room.nearest_check_in_date = data;
        },
    }
}
</script>

<style lang="scss" scoped>
.status-point {
    width: 12px;
    height: 12px;
    border-radius: 15px;
    display: inline-flex;

    &.green-point {
        background: #42D829;
    }

    &.red-point {
        background: #FF4F4F;
    }
}

.btn-grey.v-btn {
    width: calc(100% - 80px);
}

.btn-gradient.v-btn.short-btn {
    width: calc(100% - 40px);
}
</style>